import { toString } from '@/utils/string';

export const getPercentageIncrease = (newVal: number | null | undefined, oldVal: number | null | undefined) => {
  const newNum = parseInt(toString(newVal));
  const oldNum = parseInt(toString(oldVal));

  const increaseValue = newNum - oldNum;
  return Number(((increaseValue / oldNum) * 100).toFixed(2));
};

export const countDecimalPlaces = (value: number) => {
  return value?.toString()?.split('.')?.[1]?.length || 0;
};

/**
 * Rounds value to nearest given reference value
 *
 * @param {Number} value - The value that needs to be rounded
 * @param {Number} roundTo - Reference value based on which we round
 * @returns {Number} - Result of rounding
 */
export const roundUpToNearest = (value: number, roundTo: number) => {
  const factor = Math.pow(10, countDecimalPlaces(roundTo));

  return (Math.ceil(value / roundTo) * Math.floor(roundTo * factor)) / factor;
};

export { toNumberOrNull } from '@pequity/squirrel';
